"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Close = function Close(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.8695707,9.74965997 L13.3878941,7.22872604 C13.4566389,7.13648614 13.4923166,7.03032323 13.4923166,6.91458826 C13.4923166,6.78928122 13.4488072,6.67963756 13.3670095,6.59783991 L12.8979783,6.12880871 C12.7413445,5.97217492 12.4863795,5.94258853 12.2435972,6.12880871 L9.74615829,8.62624757 L7.22522436,6.10792421 C7.03204268,5.96347304 6.75097203,5.97217492 6.59433824,6.12880871 L6.12530704,6.59783991 C6.04350939,6.67963756 6,6.78928122 6,6.91458826 C6,7.03032323 6.0356777,7.13648614 6.12530704,7.25222111 L8.6227459,9.74965997 L6.10442253,12.2705939 C6.0356777,12.3628338 6,12.4689967 6,12.5847317 C6,12.7100387 6.04350939,12.8196824 6.12530704,12.90148 L6.59433824,13.3705112 C6.75184222,13.527145 7.00680723,13.5584718 7.24871943,13.3705112 L9.74615829,10.8730724 L12.2670922,13.3913957 C12.3593321,13.4601406 12.465495,13.4958183 12.58123,13.4958183 C12.706537,13.4958183 12.8161807,13.4523089 12.8979783,13.3705112 L13.3670095,12.90148 C13.4488072,12.8196824 13.4923166,12.7100387 13.4923166,12.5847317 C13.4923166,12.4689967 13.4566389,12.3628338 13.3670095,12.2470988 L10.8695707,9.74965997 Z",
    id: "close"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#close"
  }));
};

var _default = Close;
exports["default"] = _default;
module.exports = exports["default"];